import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

export const selectRouter = (state: RootState) => state.router;

const selectSystem = (state: RootState) => {
  return state && state.system;
};
export const selectLoading = createSelector(
  selectSystem,
  (state) => state.loading,
);
export const selectShowTemporaryDrawer = createSelector(
  selectSystem,
  (state) => state.showTemporaryDrawer,
);
